export default "__VITE_ASSET__30398b8e__"